/*
 * Copyright (c) 2023. Selldone® Business OS™
 *
 * Author: M.Pajuhaan
 * Web: https://selldone.com
 * ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * All rights reserved. In the weave of time, where traditions and innovations intermingle, this content was crafted.
 * From the essence of thought, through the corridors of creativity, each word, and sentiment has been molded.
 * Not just to exist, but to inspire. Like an artist's stroke or a sculptor's chisel, every nuance is deliberate.
 * Our journey is not just about reaching a destination, but about creating a masterpiece.
 * Tread carefully, for you're treading on dreams.
 */

export enum StorefrontRoutesName {
  // 🟢 Common > Blog
  BLOGS_PAGE = "Blogs",
  AUTHOR_PAGE = "AuthorPage",

  //━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

  AVOCADO_PAGE = "AvocadoPage",
  HYPER_PAGE = "HyperPage",

  MAP_PRODUCTS_PAGE = "ShopMap",

  CUSTOM_HOME_PAGE = "CustomHomePage",
  INSTAGRAM_PAGE = "InstagramPage",

  SHOP_PAGE = "ShopPage",

  SHOP_CATEGORY_PAGE = "ShopCategoryPage",
  SHOP_VENDOR_PAGE = "VendorPublicPage",
  SHOP_VENDOR_CUSTOM_LANDING_PAGE = "VendorCustomLandingPage",

  PAGE_RENDER = "PageRender",

  INCLUDE_PAGE_RENDER = "IncludePageRender",
  PRODUCT_PAGE = "ProductPage",

  COMPARISON_PAGE = "ComparisonPage",
  SHOP_INFO_PAGE_MOBILE = "ShopInfoPageMobile",
  BASKET_PAGE = "BasketPage",
  ORDERS_PAGE = "OrdersPage",

  HISTORY_ORDERS_PHYSICAL = "HistoryOrdersPhysical",
  HISTORY_ORDERS_VIRTUAL = "HistoryOrdersVirtual",
  HISTORY_ORDERS_FILE = "HistoryOrdersFile",
  HISTORY_ORDERS_SERVICE = "HistoryOrdersService",
  HISTORY_ORDERS_SUBSCRIPTION = "HistoryOrdersSubscription",
  HISTORY_ORDERS_POS = "HistoryOrdersPOS",
  HISTORY_ORDERS_AVOCADO = "HistoryOrdersAvocado",

  USER_PROFILE_PAGE = "UserProfilePage",
  USER_ADDRESSES_PAGE = "UserAddressesPage",
  USER_RETURN_REQUESTS = "UserReturnRequests",
  USER_FAVORITES_PAGE = "UserFavoritesPage",
  USER_COMMENTS_PAGE = "UserCommentsPage",
  USER_GIFTCARDS_PAGE = "UserGiftCardsPage",
  LOGIN_REDIRECT = "LoginRedirect",
  SHOP_BLOGS_PAGE = "ShopBlogsPage",
  SHOP_BLOG_PAGE_SLUG = "ShopBlogPageSlug",
  SHOP_BLOG_PAGE = "ShopBlogPage",
  USER_WALLETS_PAGE = "UserWalletsPage",


  SHOP_PROFILE_PAGE_ABOUT_US = "ShopProfilePage_AboutUs",
  SHOP_PROFILE_PAGE_TERMS = "ShopProfilePage_Terms",
  SHOP_PROFILE_PAGE_PRIVACY = "ShopProfilePage_Privacy",
  SHOP_CONTACT_US = "ShopContactUs",

  SHOP_LOGIN_PAGE = "ShopLoginPage",

}
